export var avatarShape;

(function (avatarShape) {
  avatarShape["CIRCLE"] = "circle";
  avatarShape["SQUARE"] = "square";
  avatarShape["ROUNDED"] = "rounded";
  avatarShape["RECTANGLE"] = "rectangle";
})(avatarShape || (avatarShape = {}));

export var avatarType;

(function (avatarType) {
  avatarType["TEXT"] = "text";
  avatarType["IMAGE"] = "image";
  avatarType["ICON"] = "icon";
})(avatarType || (avatarType = {}));

export var avatarSize;

(function (avatarSize) {
  avatarSize["SMALL"] = "small";
  avatarSize["MEDIUM"] = "medium";
  avatarSize["LARGE"] = "large";
})(avatarSize || (avatarSize = {}));

export var avatarFill;

(function (avatarFill) {
  avatarFill["SOLID"] = "solid";
  avatarFill["OUTLINE"] = "outline";
})(avatarFill || (avatarFill = {}));

export var avatarThemeColor;

(function (avatarThemeColor) {
  avatarThemeColor["PRIMARY"] = "primary";
  avatarThemeColor["SECONDARY"] = "secondary";
  avatarThemeColor["TERTIARY"] = "tertiary";
  avatarThemeColor["INFO"] = "info";
  avatarThemeColor["SUCCESS"] = "success";
  avatarThemeColor["WARNING"] = "warning";
  avatarThemeColor["ERROR"] = "error";
  avatarThemeColor["DARK"] = "dark";
  avatarThemeColor["LIGHT"] = "light";
  avatarThemeColor["INVERSE"] = "inverse";
  avatarThemeColor["INHERIT"] = "inherit";
})(avatarThemeColor || (avatarThemeColor = {}));

export var cardOrientation;

(function (cardOrientation) {
  cardOrientation["HORIZONTAL"] = "horizontal";
  cardOrientation["VERTICAL"] = "vertical";
})(cardOrientation || (cardOrientation = {}));

export var cardType;

(function (cardType) {
  cardType["DEFAULT"] = "default";
  cardType["primary"] = "primary";
  cardType["INFO"] = "info";
  cardType["SUCCESS"] = "success";
  cardType["WARNING"] = "warning";
  cardType["ERROR"] = "error";
})(cardType || (cardType = {}));

export var cardActionsLayout;

(function (cardActionsLayout) {
  cardActionsLayout["START"] = "start";
  cardActionsLayout["CENTER"] = "center";
  cardActionsLayout["END"] = "end";
  cardActionsLayout["STRETCHED"] = "stretched";
})(cardActionsLayout || (cardActionsLayout = {}));